module.exports = __webpack_public_path__ + "img/SP_JP.6fc78181.svg";